import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};
export const clearActionSx: SxStyle = {
  margin: 'auto',
  display: 'block',
  fontSize: (p) => p.typography.body1.fontSize,
};
